<template lang="html">
    <div class="single-avatar">
        <!-- menu when click on avatar -- if image juste delete & change, else add image -->
        <v-menu offset-y>
            <div slot="activator">
                <avatar :defaultImg="defaultImg"  :field="field" :size="size" :item="item" @click.native="changeMenu()"></avatar>

                <div class="overlay" :style="'width: ' + size + '; height: ' + size + ';'">
                    <v-icon>mode_edit</v-icon>
                </div>
            </div>
           <v-list>
             <v-list-tile v-for="item in items" :key="item.title" @click="menuActions(item)" class="li">
               <v-list-tile-title>{{ item.title }}</v-list-tile-title>
             </v-list-tile>
           </v-list>
         </v-menu>

        <!-- input hidden -- on click on menu item simulate click on this input  -->
         <input type="file" ref="fileInput" style="display:none;" @change="onFileChange"/>

        <!-- modal to confirm remove avatar  -->
         <v-dialog v-model="confirmRemove" max-width="750px">
             <v-card>
                 <v-card-title class="warning">
                     <h2>
                         <v-icon>warning</v-icon>
                         <span>Attention</span>
                     </h2>
                     <v-btn small icon @click="confirmRemove = false">
                         <v-icon>close</v-icon>
                     </v-btn>
                 </v-card-title>
                 <v-card-text>
                     Voulez vous vraiment supprimer l'avatar ?
                 </v-card-text>

                 <v-card-actions>
                   <v-spacer></v-spacer>
                   <v-btn round small outline color="warning" @click.native="confirmRemove = false;">Annuler</v-btn>
                   <v-btn round depressed small color="warning" @click.native="removeFile">Valider</v-btn>
                 </v-card-actions>
             </v-card>
         </v-dialog>

    </div>
</template>
<script>
    import Avatar from '../avatar/Avatar.vue'

    export default {
        components: { Avatar },

        props: {
            size: {
                type: String,
                required: false,
                default: '10rem'
            },
            item: {
                type: Object,
                required: true
            },
            isEditable: {
                type: Boolean,
                required: false,
                default: false
            },
            entities: {
                type: String,
                required: true,
            },
            field: {
                type: String,
                required: true,
            },
            itemId: {
              type: Number,
              required: false
            },
            defaultImg: {
                required:false
            },
            storeKey: {
              required:false
            }
        },

        data() {
            return {
                show: false,
                items: [],
                confirmRemove: false,
            }
        },
        methods: {
            // change the menu if image already here or not
            changeMenu() {
                let actualData;
                if (this.storeKey) {

                  let path    = this.$store.state.single.data
                  let split   = this.storeKey.split('.')

                  split.forEach((item, index) => {
                    if((index + 1) < split.length) {
                      let start = item.indexOf('[')
                      let end = item.indexOf(']')
                      if(start > -1 && end > -1) {
                        let i = item.substring((start + 1), end)
                        path = path[item.substring(0, start)]
                        path = path[i]

                      } else {
                        path = path[item]
                      }

                    } else {
                      actualData = path[item]
                    }
                  })

                }
                else {
                  actualData = this.$store.state.single.data[this.field];
                }


                if (actualData != null) {
                    this.items = [
                        { title: 'Sélectionner une nouvelle image', action: 'updateImg' },
                        { title: 'Supprimer l\'image actuelle', action: 'deleteImg' },
                    ];
                }
                else {
                    this.items = [
                        { title: 'Sélectionner une image', action: 'updateImg' },
                    ];
                }
                this.show = true


            },
            // click on menu item
            menuActions(item) {
                if (item.action == 'updateImg') {
                    this.$refs.fileInput.click();
                }
                else if (item.action == "deleteImg") {
                    this.confirmRemove = true;
                }
            },
            // when file is charged
            onFileChange(event) {

                let acceptType = ['image/png', 'image/jpeg', 'image/gif'];
                let file = event.target.files[0];
                if (acceptType.includes(file.type)) {
                    this.attachment = file;
                    this.selectedImg = file.name;
                    // created data element
                    let data = new FormData();
                    // put the file & size (resize on back)
                    data.append('file', this.attachment);
                    data.append('size', 750);
                    // post the data item
                    this.axios.post(`/api/${this.entities}/${this.itemId ? this.itemId : this.$route.params.id}/file/field/${this.field}`, data, {
                    headers: {
                         'Content-Type': 'multipart/form-data'
                     }
                    })
                    .then(response => {
                       this.$store.dispatch('updateSingleData', { key: this.storeKey != null ? this.storeKey : this.field, value: response.data})

                    })
                    .catch(error => {
                        this.$eventHub.$emit('open-snackbar', 'error','Un problème est survenu')
                    });
                }


            },
            // method to remove file
            removeFile() {
                this.axios.delete(`/api/${this.entities}/${this.itemId ? this.itemId : this.$route.params.id}/file/field/${this.field}`)
                    .then(response => {
                        this.$store.dispatch('updateSingleData', { key: this.storeKey != null ? this.storeKey : this.field, value: null})
                        this.confirmRemove = false;
                    })
                    .catch(error => {
                        this.$eventHub.$emit('open-snackbar', 'error','Un problème est survenu')
                    });
            }
        },

    }
</script>

<style lang="stylus" scoped>
    @require '../../assets/css/variables'

    div.single-avatar {
        position: relative
        &:hover {
            cursor: pointer

            div.overlay {
                opacity: 1
            }
        }


        div.overlay {
            transition: opacity ease-out 300ms
            position: absolute
            top: 50%
            left: 50%
            width: 100%
            height: 100%
            margin: -2rem 0 0
            border-radius: 50%
            background-color: rgba(0, 0, 0, 0.5)
            transform: translate(-50%, -50%)
            opacity: 0

            .icon {
                position: absolute
                top: 50%
                left: 50%
                color: #fff
                transform: translate(-50%, -50%)
            }
        }
    }

    .dialog {

        letter-spacing: -0.4px
        .card {
            .card__title {
                justify-content: space-between
                padding: 1.5rem 2rem
                background: $primary-light-color

                h2 {
                    display: flex
                    align-items: center
                    margin: 0
                    color: #fff
                    font-size: 1.8rem
                    font-weight: 500

                    .icon {
                        margin: 0 1.5rem 0 0
                        font-size: 3rem
                        color: #fff !important
                    }
                }
                button {
                    margin: 0

                    .icon {
                        font-size: 2rem
                        color: #fff
                    }
                }
            }
            .card__actions {
                padding:20px 15px;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/avatar/UploadAvatar.vue